import React, { useState } from 'react'
import { useFormik } from 'formik'

// components
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component';
import InputField from '../../../components/forms/InputField/InputField.component';

// mui
import { Container } from '@mui/system';
export default function LoginForm({ handleSubmit }) {
    
    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        }
    });

    const onButtonClick = (e) => {
        e.preventDefault()
        handleSubmit(formik.values)
    }

    return (<Container disableGutters sx={{ marginTop: 4}}>
            <InputField
                id="username"
                placeholder="Username"
                type="text"
                onChange={formik.handleChange}
                value={formik.values.username}
            />

            <InputField
                id="password"
                placeholder="Password"
                type="password"
                onChange={formik.handleChange}
                value={formik.values.password}
            />


        <ActionButton label='Login' color='success' onClick={onButtonClick} sx={{ marginTop: 4}} />
    </Container>)
}